import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Styles
import styles from './maincontent.module.scss';
// Store
import { IRootState } from '../../../redux';
import { hideSidebar } from '../../../redux/sidebar/actions';
import { ISidebarState } from '../../../redux/sidebar/interfaces';

export const MainContent: FC = ({ children }) => {
    const dispatch = useDispatch();
    const { sidebarShown } = useSelector<IRootState, ISidebarState>(({ sidebar }) => sidebar);

    const onOverlayClick = (e: React.MouseEvent): void => {
        dispatch(hideSidebar());
    };

    return (
        <section id="mainContent" className={`d-flex flex-row flex-fill ${styles.mainContent}`}>
            {sidebarShown && <div className={`d-flex d-md-none ${styles.sidebarOverlay}`} onClick={onOverlayClick} />}
            {children}
        </section>
    );
};
